<template>
    <div>
        <!-- Troca de Plantão -->
        <div class="modal fade" id="plantaoVendaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="base && agenda">
                    <div class="modal-header">
                        <h5 class="modal-title">Venda</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <h5 class="mb-0" v-if="agenda.local">{{ agenda.local }}</h5>
                            <div><b>{{ agenda.search }}</b></div>
                            <div>Responsável: {{ base.usuario.search }}</div>
                            <div>Data: {{ $util.getFormatDate(base.dt_escala) }}</div>
                        </div>

                        <div class="alert alert-secondary" v-if="base && base.movimentacao && base.movimentacao.usuario_destino">
                            Para: {{ base.movimentacao.usuario_destino.pessoa.st_nome }}
                        </div>

                        <template v-if="!base.movimentacao">

                            <az-input
                                type="button-group"
                                :optionsList="[
                                    { id: 'T', search: 'Todos' },
                                    { id: 'E', search: 'Específico' },
                                ]"
                                v-model="tipo_venda"
                                />

                            <div v-if="tipo_venda == 'E'" class="mt-3">

                                <az-input
                                    placeholder="Selecione o usuário..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="usuarios.index" 
                                    optionsName="filtro-usuarios"
                                    :optionsParm="{ where: { fl_ativo: true } }"
                                    :optionsSync="false"
                                    required
                                    :validate="validate"
                                    v-model="usuario_destino">
                                </az-input>

                            </div>

                            <div class="mt-3 mb-5">

                                <az-input 
                                    type="textarea"
                                    label="Observação"
                                    v-model="obs" />

                            </div>

                        </template>

                        <template v-else>

                            <p class="alert alert-secondary" v-if="base.movimentacao.st_observacao">
                                {{ base.movimentacao.st_observacao }}
                            </p>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="remover()" color="danger" v-if="base.movimentacao" v-show="base.movimentacao.id_usuario == $store.state.user.id_usuario">Remover Anuncio</az-submit>
                        <az-submit @click="atualizar()" v-else>Anunciar Venda</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            usuario_destino: "",
            data: "", 
            base: "",
            validate: false, 
            opcoes: null, 
            agenda: null, 
            tipo_venda: 'T',
            obs: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit
    },

    computed: { 
        selecionado: function () { 
            if ( !this.opcoes )
                return;

            return this.opcoes.lista.find(item => item.selec); 
        },

        escalado: function () { 
            if ( !this.opcoes )
                return;

            return this.opcoes.lista.find(item => item.id_usuario == this.base.id_usuario); 
        }
    },

    methods: { 
        selecionar (opcao) { 
            this.opcoes.lista.forEach(element => {
                element.selec = false;
            });

            opcao.selec = true;
        },

        remover () { 
            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'cancelar_movimentacao',
                dados: { 
                    id_plantao_movimentacao: this.base.movimentacao.id_plantao_movimentacao,
                    motivo: 'cancelar',
                },
                toast: true, 
                modal: 'plantaoVendaModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        vender (plantao, agenda) { 
            this.data = "";
            this.opcoes = null; 
            this.validate = false;
            this.usuario_destino = "";
            this.obs = "";
            this.tipo_venda = 'T';

            this.base = _.cloneDeep(plantao);
            this.agenda = _.cloneDeep(agenda);

            $('#plantaoVendaModal').modal('show');
        },

        editar (plantao, agenda) { 

            this.base = _.cloneDeep(plantao);
            this.agenda = _.cloneDeep(agenda);

            $('#plantaoVendaModal').modal('show');

        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'anunciar_venda',
                dados: { 
                    id_plantao_escala: this.base.id_plantao_escala, 
                    observacao: this.obs, 
                    para: this.usuario_destino,
                },
                toast: true,
                modal: 'plantaoVendaModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>